import { AlphabeticalItem, Group } from 'organisms/AlphabeticalItemsPage/type';

export const getGroupBrandsByCharacters = (brands: AlphabeticalItem[]) => {
  const sortedBrands = brands
    .map(({ id, name, full_slug }) => ({
      id,
      name,
      href: full_slug,
      isHighlighted: false,
    }))
    .sort((a, b) => a.name.localeCompare(b.name));

  const groups: Record<Group, AlphabeticalItem[]> = {
    'A-D': [],
    'E-K': [],
    'L-R': [],
    'S-Z': [],
    '0-9': [],
  };

  const firstBrandByLetter = new Set<string>();

  sortedBrands.forEach((brand) => {
    const firstLetter = brand.name[0].toUpperCase();

    if (!firstBrandByLetter.has(firstLetter)) {
      firstBrandByLetter.add(firstLetter);
      brand.isHighlighted = true; // highlight first brand in every character group
    }

    (Object.keys(groups) as Group[]).forEach((group) => {
      const regex = new RegExp(`[${group}]`, 'i'); // example: /[A-D]/i

      if (regex.test(firstLetter)) {
        groups[group].push(brand);
      }
    });
  });

  return groups;
};

export const handlePdfLink = (href?: string) => {
  if (href?.includes('http')) {
    return href.includes('pdf')
      ? `/api/media?type=pdf&originUrl=${href}`
      : href;
  }

  return href?.startsWith('/') ? href : `/${href}`;
};
